import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import screen from 'superior-mq';
import objectPath from 'object-path';
import { format, getYear } from 'date-fns';
import { rem } from 'polished';
import { bp } from 'Styles/helpers';
import HistoryCarousel from './history-carousel';
import LazyImg from '../../lazy-img';
import MdLink from '../../render-md/md-link';

export default class AboutHistory extends PureComponent {

  static propTypes = {
    slides: PropTypes.array,
  }

  static defaultProps = {
    slides: [],
  }

  render() {
    const { slides } = this.props;

    if (slides.length < 1) return null;
    const slidesWithDates = slides.filter(slide => objectPath.has(slide, 'fields.eventDate'));

    /* eslint-disable no-param-reassign, no-nested-ternary */
    slidesWithDates.sort((a, b) => {
      if (a.fields && b.fields) {
        a = new Date(a.fields.eventDate);
        b = new Date(b.fields.eventDate);
      }

      return a < b ? -1 : a > b ? 1 : 0;
    });

    // eslint-disable-next-line array-callback-return
    const slideDates = slidesWithDates.map((slide) => {
      if (objectPath.has(slide, 'fields.eventDate')) {
        return getYear(slide.fields.eventDate);
      }
    });

    return (
      <HistoryCarousel
        slides={slides}
        slideDates={slideDates}
        id={this.props.id}
      >

        {slidesWithDates.map(slide => (
          <Slide key={slide.sys.id}>
            <SlideHeading>{format(slide.fields.eventDate, 'MMM. YYYY')}</SlideHeading>
            <Figure>

              {objectPath.has(slide, 'fields.eventPhoto.fields.file.url') &&
                <LazyImg
                  src={`${slide.fields.eventPhoto.fields.file.url}?w=360&h=620&fit=fill&fm=jpg&fl=progressive&q=80`}
                  alt={slide.fields.eventPhoto.fields.description}
                  width={360}
                  height={620}
                />
              }

              {objectPath.has(slide, 'fields.eventDescription') &&
                <Figcaption>
                  <MdLink source={slide.fields.eventDescription} />
                </Figcaption>
              }

            </Figure>
          </Slide>
        ))}

      </HistoryCarousel>
    );
  }
}

const SlideHeading = styled.h4`
  margin-bottom: 30px;

  ${screen.below(bp.mobileSm, `
    font-size: ${rem(15)};
    margin-bottom: 20px;
  `)}
`;

const Slide = styled.div`
  width: 21%;
  overflow: visible;
  padding: 0 10px;
  opacity: ${props => props.index === props.activeSlide ? 1 : '.15'};
  transition: opacity .4s ease;

  ${props => props.index === props.activeSlide && css`
    ${screen.above(bp.portrait, `
      figcaption {
        opacity: 1;
        transition-delay: .4s;
      }
    `)}
  `}

  ${screen.below(bp.tablet, `
    width: 25%;
  `)}

  ${screen.below(bp.portrait, `
    width: 34%;
    padding: 0 5px;
  `)}

  ${screen.below(bp.mobileSm, `
    width: 51%;
  `)}
`;

const Figure = styled.figure`
  position: relative;
`;

const Figcaption = styled.figcaption`
  position: absolute;
  top: 50%;
  left: 100%;
  padding: 70px;
  width: 144%;
  background-color: ${props => props.theme.black};
  transform: translateY(-50%);
  z-index: 1;
  opacity: 0;
  transition: opacity .4s ease;
  text-align: left;

  ${screen.below(bp.desktop, `
    padding: 50px;
  `)}

  ${screen.between(bp.tablet, bp.desktopSm, `
    width: 165%;
    font-size: ${rem(18)};
  `)}

  ${screen.below(bp.tablet, `
    padding: 40px;
    font-size: ${rem(16)};
  `)}

  ${screen.below(bp.portrait, `
    display: none;
  `)}
`;
